import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch('/api/auth/forgot-password', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
    } catch { /* generic response regardless */ }
    setSent(true); setLoading(false);
  };

  return (
    <Shell title="Reset your password" subtitle="We'll email you a reset link">
      {sent ? (
        <div>
          <p style={{ fontSize: 14, color: 'var(--gray-300)', lineHeight: 1.6 }}>
            If an account exists for <strong style={{ color: 'var(--white)' }}>{email}</strong>, a password reset link is on its way. The link expires in 1 hour.
          </p>
          <div style={{ marginTop: 22, textAlign: 'center' }}><Link to="/login" style={link}>Back to sign in</Link></div>
        </div>
      ) : (
        <form onSubmit={submit}>
          <label style={labelStyle}>Email address</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" style={inputStyle}
            onFocus={e => Object.assign(e.target.style, { ...inputStyle, borderColor: 'var(--teal)' })} onBlur={e => Object.assign(e.target.style, inputStyle)} />
          <button type="submit" disabled={loading || !email} style={btn(loading || !email)}>{loading ? 'Sending...' : 'Send reset link'}</button>
          <div style={{ marginTop: 20, textAlign: 'center', fontSize: 13 }}><Link to="/login" style={link}>Back to sign in</Link></div>
        </form>
      )}
    </Shell>
  );
}

// Shared minimal auth shell (matches Login/Signup palette).
export function Shell({ title, subtitle, children }) {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--white)', marginBottom: 6, letterSpacing: '-0.02em' }}>{title}</h1>
          {subtitle && <p style={{ fontSize: 13, color: 'var(--gray-500)' }}>{subtitle}</p>}
        </div>
        <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 16, padding: '32px', boxShadow: '0 4px 20px rgba(26, 23, 20, 0.06)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export const labelStyle = { display: 'block', fontSize: 13, fontWeight: 500, color: 'var(--gray-300)', marginBottom: 8 };
export const inputStyle = { width: '100%', padding: '11px 14px', background: 'var(--navy)', border: '1px solid var(--navy-border)', borderRadius: 8, color: 'var(--white)', fontSize: 14, outline: 'none', transition: 'border-color 0.15s', boxSizing: 'border-box', marginBottom: 18 };
export const link = { color: 'var(--teal)', fontSize: 13, textDecoration: 'none', fontWeight: 600 };
export const btn = (disabled) => ({ width: '100%', padding: '12px 20px', background: disabled ? 'rgba(20, 80, 74,0.5)' : 'var(--teal)', border: 'none', borderRadius: 10, color: '#FAF7F2', fontSize: 15, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer' });
